var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "render-post",
      staticClass: "render-post hide-scrollbar render-post-linkedin",
      style: { fontSize: _vm.fontSize + "px" },
    },
    [
      _c("div", { staticClass: "container-post-content" }, [
        _c(
          "div",
          { staticClass: "post-content" },
          [
            _c("div", { staticClass: "post-header" }, [
              _c(
                "div",
                { staticClass: "img-pages" },
                [
                  _vm._l(
                    _vm.pages.slice(0, _vm.pages.length == 4 ? 4 : 3),
                    function (page, index) {
                      return [
                        _c(
                          "Tooltip",
                          {
                            key: index,
                            attrs: {
                              active: page.iconEdited,
                              text: "Voir les modifications apportées",
                              position: "right",
                              classCustom: `page ${
                                page.iconEdited ? "iconEdited" : ""
                              }`,
                            },
                            on: {
                              click: () => {
                                page.iconEdited
                                  ? _vm.$emit("clickPage", page.id)
                                  : _vm.openLinkedinPage(page)
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src:
                                  page && page.avatar
                                    ? page.avatar
                                    : "img/avatar.jpg",
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]
                    }
                  ),
                  _vm.pages.length > 4
                    ? _c("div", { staticClass: "page count" }, [
                        _vm._v(
                          "\n                        +" +
                            _vm._s(_vm.pages.length - 3) +
                            "\n                    "
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              _c("div", { staticClass: "info" }, [
                _vm.pages.length == 1
                  ? _c(
                      "p",
                      {
                        staticClass: "name",
                        on: {
                          click: function ($event) {
                            return _vm.openLinkedinPage(_vm.pages[0])
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.pages[0].name))]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "date" }, [
                  _vm._v(
                    _vm._s(_vm.datePost ? _vm.formatDatePost : "A l'instant") +
                      " • "
                  ),
                  _c("i", { staticClass: "fa-solid fa-earth-americas" }),
                ]),
              ]),
              _vm._m(0),
            ]),
            _vm.text
              ? _c("div", { staticClass: "post-text" }, [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.textTranslate) },
                  }),
                ])
              : _vm._e(),
            _vm.survey
              ? _c("div", { staticClass: "survey" }, [
                  _c("h5", [_vm._v(_vm._s(_vm.survey.question))]),
                  _c(
                    "div",
                    { staticClass: "btns" },
                    _vm._l(_vm.survey.options, function (option, index) {
                      return _c("div", { key: index, staticClass: "btn" }, [
                        _vm._v(_vm._s(option)),
                      ])
                    }),
                    0
                  ),
                  _c("div", { staticClass: "footer-survey" }, [
                    _c("p", [
                      _c("span", { staticClass: "count" }, [_vm._v("0 vote")]),
                      _vm._v("•"),
                      _c("span", { staticClass: "time" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              `dash.postcreator.postLinkedin.survey.${_vm.survey.duration}`
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ])
              : _vm.snippet.link
              ? _c(
                  "div",
                  { staticClass: "snippet" },
                  [
                    _c("SnippetNetwork", {
                      attrs: {
                        link: _vm.snippet.link,
                        imageUrlDefault:
                          _vm.snippet.customActived &&
                          _vm.snippet.image &&
                          _vm.snippet.image.id &&
                          _vm.files[_vm.snippet.image.id].isUpload
                            ? _vm.files[_vm.snippet.image.id].url
                            : undefined,
                        titleDefault:
                          _vm.snippet.customActived && _vm.snippet.title,
                      },
                    }),
                  ],
                  1
                )
              : _vm.medias.find((m) => ["pdf"].includes(m.info.type2))
              ? _vm._l(
                  _vm.medias.filter((m) => m.info.type2 == "pdf").slice(0, 1),
                  function (media) {
                    return _c(
                      "div",
                      { key: media, staticClass: "pdf-preview" },
                      [
                        _c("div", { staticClass: "navigation-bar" }, [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(media.info.customName || media.info.name)
                            ),
                          ]),
                          _c("span", [_vm._v("•")]),
                          _vm._v(
                            _vm._s(_vm.pdfPageNumber) +
                              " " +
                              _vm._s(
                                _vm.$t("dash.post-creator.render.pdf-pages")
                              ) +
                              "\n                    "
                          ),
                        ]),
                        _c("pdf", {
                          key: media.id,
                          attrs: { src: media.url, page: _vm.pdfPage },
                          on: { numpages: (n) => (_vm.pdfPageNumber = n) },
                        }),
                        _vm.pdfPage > 1
                          ? _c(
                              "div",
                              {
                                staticClass: "previous btn-nav",
                                on: { click: () => _vm.pdfPage-- },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-solid fa-chevron-left",
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm.pdfPage < _vm.pdfPageNumber
                          ? _c(
                              "div",
                              {
                                staticClass: "next btn-nav",
                                on: { click: () => _vm.pdfPage++ },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-solid fa-chevron-right",
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }
                )
              : _vm.medias.some((m) =>
                  ["video", "image"].includes(m.info.type2)
                )
              ? _c(
                  "div",
                  {
                    class: [
                      "post-medias media" + Math.min(_vm.medias.length, 4),
                      _vm.medias.find((m) =>
                        ["video", "image"].includes(m.info.type2)
                      ).info.aspectRatio > 1
                        ? "horizontal"
                        : "vertical",
                    ],
                  },
                  _vm._l(
                    _vm.medias
                      .filter((m) => ["video", "image"].includes(m.info.type2))
                      .slice(0, 4),
                    function (media, i) {
                      return _c(
                        "div",
                        {
                          key: i,
                          staticClass: "media",
                          style: {
                            aspectRatio:
                              i == 0 ? media.info.aspectRatio : "auto",
                          },
                        },
                        [
                          i == 3 && _vm.medias.length > 4
                            ? _c("div", { staticClass: "count" }, [
                                _vm._v(
                                  "+" +
                                    _vm._s(Math.min(_vm.medias.length, 20) - 3)
                                ),
                              ])
                            : _vm._e(),
                          media.info.type.startsWith("video/")
                            ? _c(
                                "div",
                                {
                                  staticClass: "media-video",
                                  class: { videoPlayed: _vm.videoPlayed },
                                  on: {
                                    click: function ($event) {
                                      return _vm.togglePlayPause()
                                    },
                                  },
                                },
                                [
                                  media.imagePreview && !_vm.videoPlayed
                                    ? _c("img", {
                                        staticClass: "imagePreview",
                                        attrs: {
                                          src: media.imagePreview.url,
                                          alt: "",
                                        },
                                      })
                                    : _vm._e(),
                                  _c("video", {
                                    ref: "videoPlayer",
                                    refInFor: true,
                                    staticClass: "video",
                                    attrs: {
                                      playsinline: "",
                                      preload: "metadata",
                                      loop: "",
                                      autoPlay: _vm.videoPlayed,
                                      src: media.url,
                                      type: media.info.type,
                                    },
                                  }),
                                ]
                              )
                            : _c("img", {
                                style: {
                                  aspectRatio:
                                    i == 0 ? media.info.aspectRatio : "auto",
                                },
                                attrs: { src: media.url, alt: "" },
                              }),
                        ]
                      )
                    }
                  ),
                  0
                )
              : !_vm.text
              ? _c("div", { staticClass: "post-empty" })
              : _vm._e(),
            _c("div", { staticClass: "post-footer" }, [
              _c("div", { staticClass: "top" }, [
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.comments.length ? "1" : "0") +
                      " commentaires • 0 republication"
                  ),
                ]),
              ]),
              _c("div", { staticClass: "bottom" }, [
                _c("div", { staticClass: "like" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        height: "auto",
                        width: "auto",
                        viewBox: "0 0 24 24",
                        "aria-hidden": "true",
                        role: "none",
                        "data-supported-dps": "24x24",
                        fill: "currentColor",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M19.46 11l-3.91-3.91a7 7 0 01-1.69-2.74l-.49-1.47A2.76 2.76 0 0010.76 1 2.75 2.75 0 008 3.74v1.12a9.19 9.19 0 00.46 2.85L8.89 9H4.12A2.12 2.12 0 002 11.12a2.16 2.16 0 00.92 1.76A2.11 2.11 0 002 14.62a2.14 2.14 0 001.28 2 2 2 0 00-.28 1 2.12 2.12 0 002 2.12v.14A2.12 2.12 0 007.12 22h7.49a8.08 8.08 0 003.58-.84l.31-.16H21V11zM19 19h-1l-.73.37a6.14 6.14 0 01-2.69.63H7.72a1 1 0 01-1-.72l-.25-.87-.85-.41A1 1 0 015 17l.17-1-.76-.74A1 1 0 014.27 14l.66-1.09-.73-1.1a.49.49 0 01.08-.7.48.48 0 01.34-.11h7.05l-1.31-3.92A7 7 0 0110 4.86V3.75a.77.77 0 01.75-.75.75.75 0 01.71.51L12 5a9 9 0 002.13 3.5l4.5 4.5H19z",
                        },
                      }),
                    ]
                  ),
                  _vm._v(
                    "\n                        J'aime\n                    "
                  ),
                ]),
                _c("div", { staticClass: "comments" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        height: "auto",
                        width: "auto",
                        viewBox: "0 0 24 24",
                        "aria-hidden": "true",
                        role: "none",
                        "data-supported-dps": "24x24",
                        fill: "currentColor",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M7 9h10v1H7zm0 4h7v-1H7zm16-2a6.78 6.78 0 01-2.84 5.61L12 22v-4H8A7 7 0 018 4h8a7 7 0 017 7zm-2 0a5 5 0 00-5-5H8a5 5 0 000 10h6v2.28L19 15a4.79 4.79 0 002-4z",
                        },
                      }),
                    ]
                  ),
                  _vm._v(
                    "\n                        Commenter\n                    "
                  ),
                ]),
                _c("div", { staticClass: "share" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        height: "auto",
                        width: "auto",
                        viewBox: "0 0 24 24",
                        "aria-hidden": "true",
                        role: "none",
                        "data-supported-dps": "24x24",
                        fill: "currentColor",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M13.96 5H6c-.55 0-1 .45-1 1v10H3V6c0-1.66 1.34-3 3-3h7.96L12 0h2.37L17 4l-2.63 4H12l1.96-3zm5.54 3H19v10c0 .55-.45 1-1 1h-7.96L12 16H9.63L7 20l2.63 4H12l-1.96-3H18c1.66 0 3-1.34 3-3V8h-1.5z",
                        },
                      }),
                    ]
                  ),
                  _vm._v(
                    "\n                        Republier\n                    "
                  ),
                ]),
                _c("div", { staticClass: "send" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        height: "auto",
                        width: "auto",
                        viewBox: "0 0 24 24",
                        "aria-hidden": "true",
                        role: "none",
                        "data-supported-dps": "24x24",
                        fill: "currentColor",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M21 3L0 10l7.66 4.26L16 8l-6.26 8.34L14 24l7-21z",
                        },
                      }),
                    ]
                  ),
                  _vm._v(
                    "\n                        Envoyer\n                    "
                  ),
                ]),
              ]),
            ]),
            _vm.comments && _vm.comments.length
              ? _c(
                  "div",
                  { staticClass: "container-comments" },
                  [
                    _c("h5", [_vm._v("Commentaires")]),
                    _vm._l(_vm.commentsTranslate, function (comment) {
                      return _c("div", { staticClass: "first-comment" }, [
                        _c("div", { staticClass: "image-auteur" }, [
                          _c("img", {
                            attrs: {
                              src:
                                !_vm.pages ||
                                !_vm.pages.length ||
                                _vm.pages.length > 1 ||
                                !_vm.pages[0] ||
                                !_vm.pages[0].avatar
                                  ? "img/avatar.jpg"
                                  : _vm.pages[0].avatar,
                              alt: "",
                            },
                          }),
                        ]),
                        _c("div", { staticClass: "content-comment" }, [
                          _c("p", { staticClass: "header-comment" }, [
                            _c("span", { staticClass: "name" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.pages.length > 1
                                    ? "Commentaire"
                                    : _vm.pages[0].name
                                )
                              ),
                            ]),
                            _c("span", { staticClass: "date" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.datePost
                                    ? _vm.formatDatePost
                                    : "A l'instant"
                                )
                              ),
                            ]),
                          ]),
                          _c("p", {
                            staticClass: "comment",
                            domProps: { innerHTML: _vm._s(comment) },
                          }),
                        ]),
                      ])
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "more" }, [
      _c("i", { staticClass: "fa-solid fa-ellipsis" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }